var _rect, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 52,
    viewBox: "0 0 79 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 39.9707,
    width: 43.8695,
    height: 9.92953,
    rx: 4.96476,
    fill: "#027BC7",
    stroke: "#C8D1EA",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5053,
    cy: 44.9355,
    r: 1.42429,
    fill: "#027BC7",
    stroke: "#C8D1EA",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5862,
    cy: 44.9355,
    r: 1.42429,
    fill: "#027BC7",
    stroke: "#C8D1EA",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6672,
    cy: 44.9355,
    r: 1.42429,
    fill: "#027BC7",
    stroke: "#C8D1EA",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.748,
    cy: 44.9355,
    r: 1.42429,
    fill: "#027BC7",
    stroke: "#C8D1EA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84863 34.4303V23.5759H15.0018V6.95508H35.3082L42.8291 23.5759V34.4303H4.84863Z",
    fill: "#C8D1EA",
    stroke: "#C8D1EA",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6064 20.5009V12.3997C20.6064 11.8474 21.0542 11.3997 21.6064 11.3997H31.6713C32.0678 11.3997 32.4269 11.634 32.5866 11.9969L36.1511 20.0981C36.4419 20.759 35.9579 21.5008 35.2358 21.5008H21.6064C21.0542 21.5008 20.6064 21.0531 20.6064 20.5009Z",
    fill: "#027BC7",
    stroke: "#027BC7",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9707 4.53076L69.9002 26.3493L65.0516 30.3898L52.9302 12.6117",
    stroke: "#C8D1EA",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9738 11.6117L56.9707 5.33899L69.6015 26.2782L65.1995 29.3177L52.9738 11.6117Z",
    fill: "#C8D1EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2331 35.2383L56.5667 4.53072L48.8898 1.29834L40.4048 19.8845",
    stroke: "#C8D1EA",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1365 38.7277C68.1219 39.6341 66.161 40.2205 63.6451 40.4496C61.1856 40.6736 58.4058 40.5394 55.9674 40.1896C53.4903 39.8342 51.5131 39.2776 50.5782 38.7399C50.5705 38.7355 50.5635 38.7299 50.5562 38.7255C50.6401 38.6865 50.7393 38.6435 50.8572 38.5993C52.5795 37.9534 54.7894 36.6913 57.0912 35.208C59.409 33.7145 61.8784 31.9575 64.1363 30.2841C66.3957 28.6094 68.4515 27.0113 69.9416 25.8326C70.6108 25.3033 71.1665 24.8582 71.5759 24.5281C74.4613 28.5744 73.6084 34.7317 69.1365 38.7277Z",
    fill: "#027BC7",
    stroke: "#027BC7",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1072 21.5007L47.7541 21.9967L44.8496 31.6019L42.021 31.677L43.1072 21.5007Z",
    fill: "#C8D1EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.366,
    y: 1.85522,
    width: 7.41248,
    height: 20.9704,
    transform: "rotate(24.6765 49.366 1.85522)",
    fill: "#C8D1EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4338,
    y: 7.29834,
    width: 9.76208,
    height: 26.571,
    transform: "rotate(24.2153 45.4338 7.29834)",
    fill: "#C8D1EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.2e096b9856f7ba5a5a8bef6e39f20d63.svg";
export { ForwardRef as ReactComponent };